import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const EntryContainer = styled.div`
  height: 300px;
`;


// WEBPACK FOOTER //
// ./src/components/Panels/CustomPanel/styled.js